<template>
  <AssayDescription :dv="dv" />
  <AssayAcquisitionDetailsSection :dv="dv" />
</template>

<script>
import AssayAcquisitionDetailsSection from './shared/AssayAcquisitionDetailsSection.vue'
import AssayDescription from './shared/AssayDescription.vue'

export default {
  name: 'GenericAssay',
  components: {
    AssayDescription,
    AssayAcquisitionDetailsSection,
  },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
